import { sortByText } from 'utils/sort-by-text';
import { SchedulerResourceType } from '../resource-types';

export const getDemandSorter = () => ({
  fn: (recordA, recordB) => {
    const typeA = recordA.get('type');
    const typeB = recordB.get('type');

    if (
      typeA === SchedulerResourceType.DemandRole &&
      typeB === SchedulerResourceType.DemandRole
    ) {
      return sortByText(recordA.get('roleName'), recordB.get('roleName'));
    }

    return 0;
  },
});
